import React from 'react';
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="AI Agents in Action by Micheal Lanham"
        desc="A hands-on guide to building AI agents and multi-agent systems using large language models"
        keyword="ai agents, llm, large language models, micheal lanham, multi-agent systems, autonomous agents"
        image="/images/books/ai-agents-in-action.jpg"
        pageType="book"
        author="Micheal Lanham"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/ai-agents-in-action.jpg"
                alt="AI Agents in Action by Micheal Lanham"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                AI Agents in Action
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Micheal Lanham</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                AI Agents in Action is a practical guide to building autonomous AI systems powered by
                large language models. Micheal Lanham takes you from the fundamentals of LLM-based
                agents all the way to designing and deploying multi-agent systems that can reason,
                plan, and act in the real world.
              </p>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                The book covers the core building blocks of AI agents — tools, memory, and
                orchestration — and shows how to combine them into systems capable of handling
                complex, multi-step tasks. You'll learn how agents perceive their environment, make
                decisions, and take actions using frameworks like LangChain and AutoGen.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Whether you're building a single-agent assistant or a team of collaborating agents,
                this book provides the patterns and hands-on examples to bring your ideas to
                production. A must-read for engineers looking to move beyond simple LLM integrations
                and build genuinely intelligent systems.
              </p>
            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
